import { SidebarItemType } from 'types/sidebar';

const dashboardItemList: SidebarItemType[] = [
  {
    path: 'home',
    href: '/home',
    name: '홈',
    isShow: true,
    children: [{ href: '/home/status-board', name: 'LOTO 현황판' }],
  },
  {
    path: 'loto-status',
    href: '/loto-status/conclusion',
    name: 'LOTO 현황',
    isShow: true,
    children: [
      { href: '/loto-status/conclusion', name: '체결 현황' },
      { href: '/loto-status/longTerm', name: '장기 체결 현황' },
      { href: '/loto-status/action', name: '부착 현황' },
      { href: '/loto-status/communication', name: '통신 현황' },
    ],
  },
  {
    path: 'loto-management',
    href: '/loto-management/setting',
    name: 'LOTO 관리',
    isShow: true,
    children: [
      {
        href: '/loto-management/permission',
        name: '허가서 관리',
      },
      {
        href: '/loto-management/setting',
        name: 'LOTO 세팅',
      },
      {
        href: '/loto-management/box',
        name: 'LOTO Box Open 관리',
      },
      {
        href: '/loto-management/log',
        name: 'LOTO 대장',
      },
      {
        href: '/loto-management/self-permission',
        name: 'TA 허가서 관리',
      },
      {
        href: '/loto-management/permission-transfer',
        name: '허가서 이전',
      },
      {
        href: '/loto-management/permission-log',
        name: '허가서 변경 이력',
      },
    ],
  },
  {
    path: 'devices',
    href: '/devices/device',
    name: '설비 관리',
    isShow: true,
    children: [
      {
        href: '/devices/device',
        name: '설비 관리',
      },
      {
        href: '/devices/factory-position',
        name: '공장 배치 관리',
      },
      {
        href: '/devices/area-position',
        name: 'Area 배치 관리',
      },
      {
        href: '/devices/zone-position',
        name: 'Zone 배치 관리',
      },
      {
        href: '/devices/equipment-position',
        name: '설비 배치 관리',
      },
    ],
  },
  {
    path: 'lockers',
    href: '/lockers/locker',
    name: 'Lock 관리',
    isShow: true,
    children: [
      {
        href: '/lockers/locker',
        name: 'Lock 관리',
      },
    ],
  },
  {
    path: 'admin',
    href: '/admin/user',
    name: '사용자 관리',
    isShow: true,
    children: [
      {
        href: '/admin/user',
        name: '사용자 관리',
      },
      {
        href: '/admin/lock-permission',
        name: 'Lock 권한 관리',
      },
      // {
      //   href: '/admin/shift',
      //   name: '교대근무 관리',
      // },
    ],
  },
  {
    path: 'mypage',
    href: '/mypage',
    name: '내정보 관리',
    isShow: false,
    children: [
      {
        href: '/mypage',
        name: '내정보 관리',
      },
    ],
  },
];

export default dashboardItemList;
